export const SET_COUNT = 'wishlist-count/SET_COUNT'
export const INCREMENT_COUNT = 'wishlist-count/INCREMENT_COUNT'
export const DECREMENT_COUNT = 'wishlist-count/DECREMENT_COUNT'
